import { AlertInlineMain } from '@inmoment/the-kitchen';
import * as React from 'react';
import { Link } from 'react-router-dom';
import { CodeBlock } from '../../cookbook-ui/custom-components/CodeBlock/CodeBlock';

export interface Props {}

export const GenericModalDocumentation: React.FC<Props> = (props) => {
  return (
    <div>
      <AlertInlineMain color="error" title="Note!" subtitle="Pass useLegacy=false for new implementations." />
      <br />
      <AlertInlineMain
        color="warning"
        title="Deprecation Notice"
        subtitle="canScrimClose, fullScreen, contrast, isVisualModal props are all deprecated and can't be used when useLegacy=false"
      />
      <br />
      <div>
        <p>
          To display more than one GenericModal on a single page, pass a unique{' '}
          <Link to="Modals#GenericModalProps">
            <code>slotName</code>
          </Link>{' '}
          to each instance of the GenericModal. Note that this also requires changing the <code>slot</code> attribute of the modal's children to match
          the value passed to <code>slotName</code>.
        </p>
        <br />
        <p className="kxi-text-600">Example:</p>
        <CodeBlock
          monospace
          code={`<xi-generic-modal slotName="mySlot1">
  <!-- ⬇️ This must match this modal's slotName but be different from all other modals!!! -->
  <div slot="mySlot1">
    
  </div>
</xi-generic-modal>

<xi-generic-modal slotName="mySlot2">
  <!-- ⬇️ This must match this modal's slotName but be different from all other modals!!! -->
  <div slot="mySlot2"> 
    
  </div>
</xi-generic-modal>`}
        />
      </div>
      <br />
      <p>
        The <code>allowPropagation</code> prop is an escape hatch. If you are using it something is wrong. Please double check that you aren't
        including the generic modal inside of another modal or that there aren't external onClick listeners.
      </p>
    </div>
  );
};
